import { render, staticRenderFns } from "./NewUserRequest.vue?vue&type=template&id=46151f8b&scoped=true&"
import script from "./NewUserRequest.vue?vue&type=script&lang=js&"
export * from "./NewUserRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewUserRequest.vue?vue&type=style&index=0&id=46151f8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46151f8b",
  null
  
)

export default component.exports